import { createAvailability } from "../../../../redux/specialist-slices/availability.slice";
import { hideDialog, refresher } from "../../../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../../../assets/js/Icons";
import DayRow from "./dayRow";

import {
  Alert,
  Button, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Snackbar, Typography
} from "@mui/material";
import TimeUtils from "../../../../utils/time.utils";
// import { formatPrice } from "../../../../utils/helper";
import { useState } from "react";



function Availability({ handleClose }) {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.otherSlice);
  // const { specialist } = useSelector((state) => state.authSlice);
  const [validationError, setValidationError] = useState("");


  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const starts = form.getAll("start[]");
    const ends = form.getAll("end[]");

    const slots = starts.map((start, i) => ({
      start: TimeUtils.getNearestDayISO(data?.day, start),
      end: TimeUtils.getNearestDayISO(data?.day, ends[i])
    }));

    const { success } = await dispatch(createAvailability({
      slots,
      day: data?.day,
    })).unwrap() || {}
    if (success) {
      dispatch(hideDialog());
      dispatch(refresher());
    };
  }




  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ position: "relative", p: 1 }}>
        <Typography variant="dialogTitle">Add/Update slots</Typography>
        <IconButton size="small" variant="dialogCloseBtn" onClick={handleClose}>
          <Icons.Cross />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <DayRow setValidationError={setValidationError} />
        {/* <Stack spacing={2} mt={3}>

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label="30 min price"
              value={durationPricing[30]}
              onChange={(e) => setDurationPricing((prev) => ({ ...prev, 30: e.target.value }))}
              slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
            />
            <TextField
              fullWidth
              size="small"
              type="number"
              label="60 min price"
              value={durationPricing[60]}
              onChange={(e) => setDurationPricing((prev) => ({ ...prev, 60: e.target.value }))}
              slotProps={{ htmlInput: { min: 0, step: "0.01" } }}
            />
          </Stack>
          <Typography variant="caption" color="text.secondary">
            Default fallback is {formatPrice(40, "USD")} for 30 minutes and{" "}
            {formatPrice(70, "USD")} for 60 minutes if pricing is left empty.
          </Typography>
        </Stack> */}
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          type="submit"
          variant="outlined"
        >Save
        </Button>
      </DialogActions>
      <Snackbar
        open={!!validationError}
        autoHideDuration={4000}
        onClose={() => setValidationError("")}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="error"
          variant="filled"
          onClose={() => setValidationError("")}
        >
          {validationError}
        </Alert>
      </Snackbar>
    </Paper>
  )
}

export default Availability
